import { WbsDeliverableListItem } from '../../../features/feature-wbs/models/interfaces/wbs-deliverable.interface'
import { WbsMilestoneListItem } from '../../../features/feature-wbs/models/interfaces/wbs-milestone.interface'
import { WbsRisk } from '../../../features/feature-wbs/models/interfaces/wbs-risk.interface'
import { WbsWorkpackageListItem } from '../../../features/feature-wbs/models/interfaces/wbs-workpackage.interface'
import { AppProgressbarState } from '../../models/interfaces/app-progressbar-state.interface'

export interface WbsState {
   exportProgress?: AppProgressbarState
   workpackages?: WbsWorkpackageListItem[]
   isLoadingWorkpackages?: boolean
   deliverables?: WbsDeliverableListItem[]
   isLoadingDeliverables?: boolean
   milestones?: WbsMilestoneListItem[]
   isLoadingMilestones?: boolean
   risks?: WbsRisk[]
   isLoadingRisks?: boolean
   riskActive?: WbsRisk
   isLoadingRiskActive?: boolean
}

export const initialWbsState: WbsState = {}
